<template>
  <div class="form__input-container">
    <fieldset class="form__field">
      <label class="form__label" for="control" v-if="label">
        {{ L.localize(label) }}
      </label>

      <select
        id="control"
        class="form__select"
        :value="value"
        :disabled="disabled"
        :data-acc="acc"
        :name="acc"
        @input="updateValue($event.target.value)"
        @change="onChange">

          <option
            v-for="option in options"
            v-bind:value="option.value !== undefined ? option.value : option"
            :disabled="option.isDisabled">
              {{ option.label ? option.label : option }}
          </option>

      </select>
    </fieldset>
  </div>
</template>

<script>
import L from 'services/Localization'

export default {
  name: 'select-list',
  props: {
    label: String,
    acc: {
      type: String,
      required: false,
      default: ''
    },
    value: {
      type: [String, Number],
      required: false
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    options: {
      type: Array,
      required: false
    }
  },
  data() {
    return {
      L: L
    }
  },
  methods: {
    updateValue(value) {
      this.$emit('input', value)
    },
    onChange(e) {
      this.$emit('change', this.value, e)
    }
  }
}
</script >



// WEBPACK FOOTER //
// SelectList.vue?108caa98